import Image from '@/components/TailwindUI/Image'
import AppBuilderIcon from '@/pages/SpaceAppBuilder/LandingPage/components/AppBuilderIcon'
import cn from '@/utilities/cn'

type DatasourceImageProps = {
  size: 'sm' | 'lg'
  src: string | undefined
  appName: string
}
function DatasourceIcon({ size, src = '', appName }: DatasourceImageProps) {
  return (
    <Image
      loadingImage={
        <div className="animate-pulse rounded-lg bg-zinc-50">
          <div
            className={cn({
              'h-10 w-10': size === 'sm',
              'h-20 w-20': size === 'lg'
            })}
          />
        </div>
      }
      fallbackImage={
        <div>
          <AppBuilderIcon
            className={cn('rounded-lg', {
              'h-10 w-10': size === 'sm',
              'h-20 w-20': size === 'lg'
            })}
          />
        </div>
      }
      className={cn('rounded-lg', {
        'h-10 w-10 flex-none': size === 'sm',
        'h-20 w-20': size === 'lg'
      })}
      src={src}
      alt={`${appName} Icon`}
    />
  )
}
export default DatasourceIcon
